module.exports = __webpack_public_path__ + "static/media/coronavirus.34967c3b.png";